import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

type ArticleCardProps = {
  article: Article;
  layout?: "vertical" | "horizontal";
};

export default function ArticleCard({ article, layout = "vertical" }: ArticleCardProps) {
  const isHorizontal = layout === "horizontal";

  return (
    <article
      className={`group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 ${
        isHorizontal ? "flex flex-col sm:flex-row" : "flex flex-col"
      }`}
    >
      <Link
        to={`/article/${article.id}`}
        className={`relative block shrink-0 overflow-hidden ${
          isHorizontal ? "h-48 w-full sm:h-auto sm:w-56" : "h-48 w-full"
        }`}
      >
        <img
          src={article.cover}
          alt={`${article.title} 配图`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/95 px-3 py-1 text-xs font-medium text-primary-700">
          {article.categoryName}
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <Link to={`/article/${article.id}`} className="flex-1">
          <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
            {article.title}
          </h3>
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
            {article.excerpt}
          </p>
        </Link>

        <div className="mt-4 flex flex-wrap items-center gap-x-3 gap-y-1.5 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <span className="inline-flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-user-line" />
            </span>
            {article.author}
          </span>
          <span className="flex items-center gap-1">
            <span className="inline-flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-calendar-line" />
            </span>
            {article.date}
          </span>
          <span className="flex items-center gap-1">
            <span className="inline-flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-time-line" />
            </span>
            {article.readTime}
          </span>
        </div>
      </div>
    </article>
  );
}